<div id="signalr-notification-container" class="signalr-notification-bottom-right">
  @for (item of notifications; track item?.Title) {
    <div class="signalr-notification">
      <div class="signalr-notification-icon">
        <mat-icon class="notification-icon">notifications</mat-icon>
      </div>
      <div class="signalr-notification-message">
        <strong>{{ item?.Title }}</strong>
        <div
          id="parentLinkEvents"
          class="notification-message-body"
          [innerHTML]="$safeNavigationMigration(item?.ShortMessage) | sanitizedHtml"></div>
      </div>
    </div>
  }
</div>
